if(typeof __WEBPACK_EXTERNAL_MODULE__57091__ === 'undefined') { var e = new Error("Cannot find module 'postal'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__57091__;